import { MakeLogicType, connect, kea, key, path, props } from 'kea'
import { loaders } from 'kea-loaders'

import api from 'lib/api'
import { teamLogic } from 'scenes/teamLogic'

export interface SessionRecordingViewedResult {
    viewed: boolean
    otherViewers: number
}

export type SessionRecordingViewedProps = {
    sessionRecordingId: string
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface sessionRecordingViewedLogicValues {
    currentTeamId: number | null // teamLogic
    recordingViewed: any
    recordingViewedLoading: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface sessionRecordingViewedLogicActions {
    loadRecordingViewed: () => any
    loadRecordingViewedFailure: (
        error: string,
        errorObject?: any
    ) => {
        error: string
        errorObject?: any
    }
    loadRecordingViewedSuccess: (
        recordingViewed: {
            otherViewers: number
            viewed: boolean
        },
        payload?: any
    ) => {
        recordingViewed: {
            otherViewers: number
            viewed: boolean
        }
        payload?: any
    }
    userClickedThrough: () => any
    userClickedThroughFailure: (
        error: string,
        errorObject?: any
    ) => {
        error: string
        errorObject?: any
    }
    userClickedThroughSuccess: (
        recordingViewed: {
            otherViewers: any
            viewed: boolean
        },
        payload?: any
    ) => {
        recordingViewed: {
            otherViewers: any
            viewed: boolean
        }
        payload?: any
    }
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface sessionRecordingViewedLogicMeta {
    key: string
}

export type sessionRecordingViewedLogicType = MakeLogicType<
    sessionRecordingViewedLogicValues,
    sessionRecordingViewedLogicActions,
    SessionRecordingViewedProps,
    sessionRecordingViewedLogicMeta
>

export const sessionRecordingViewedLogic = kea<sessionRecordingViewedLogicType>([
    path(['lib', 'components', 'ViewRecordingButton', 'sessionRecordingViewedLogic']),
    key((props: Record<string, unknown>) => props.sessionRecordingId as string),
    props({} as unknown as SessionRecordingViewedProps),
    connect(() => ({
        values: [teamLogic, ['currentTeamId']],
    })),
    loaders(({ props, values }) => ({
        recordingViewed: {
            loadRecordingViewed: async () => {
                if (!props.sessionRecordingId || !values.currentTeamId || props.sessionRecordingId === '') {
                    return { viewed: false, otherViewers: 0 }
                }

                const response = await api.get(
                    `/api/projects/${values.currentTeamId}/session_recordings/${props.sessionRecordingId}/viewed`
                )
                return response as SessionRecordingViewedResult
            },
            userClickedThrough: async () => {
                return { viewed: true, otherViewers: values.recordingViewed?.otherViewers ?? 0 }
            },
        },
    })),
])
